import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcSun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 26v4h-2v-4h2Zm-8.879-3.536 1.415 1.415-2.829 2.828-1.414-1.414 2.828-2.829Zm15.758 0 2.828 2.829-1.414 1.414-2.829-2.828 1.415-1.415ZM16 8a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm14 4v2h-4v-2h4ZM6 14v2H2v-2h4Zm19.293-8.707 1.414 1.414-2.828 2.829-1.415-1.415 2.829-2.828Zm-18.586 0L9.536 8.12 8.12 9.536 5.293 6.707l1.414-1.414ZM17 2v4h-2V2h2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcSun;
